import { render, staticRenderFns } from "./DragAndDropInputFile.vue?vue&type=template&id=8394a884&scoped=true"
import script from "./DragAndDropInputFile.js?vue&type=script&lang=js&external"
export * from "./DragAndDropInputFile.js?vue&type=script&lang=js&external"
import style0 from "./DragAndDropInputFile.vue?vue&type=style&index=0&id=8394a884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8394a884",
  null
  
)

export default component.exports